import {
  Component,
  OnInit,
  Inject,
  forwardRef,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { DataEntityEditorBaseComponent } from '../../data-entity-editor-base/data-entity-editor-base.component';
import {
  WorkflowService,
  WorkflowContextService,
  SystemService
} from '../../../../../services';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { IssueDateDataEntity } from 'src/app/models/data-entities/issue-date-data-entity';
import { ConditionTarget } from 'src/app/components/system/condition-builder/condition-builder.model';

@Component({
  selector: 'wm-issue-date-data-entity-editor',
  templateUrl: './issue-date-data-entity-editor.component.html',
  styleUrls: ['./issue-date-data-entity-editor.component.css'],
  standalone: false
})
export class IssueDateDataEntityEditorComponent
  extends DataEntityEditorBaseComponent
  implements OnInit {
  @Input() dataEntity: IssueDateDataEntity;

  constructor(
    @Inject(forwardRef(() => WorkflowService))
    public _workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    private _context: WorkflowContextService,
    @Inject(forwardRef(() => SystemService)) private _systemSvc: SystemService,
    private changeDetRef: ChangeDetectorRef,
    private _fb: UntypedFormBuilder
  ) {
    super();
  }

  ngOnInit() {
    this.form.addControl(
      'allowEdit',
      this._fb.control(false, [Validators.required])
    );
    this.form.addControl(
      'visibleToUser',
      this._fb.control(false, [Validators.required])
    );
    this.form.addControl(
      'calc-formula',
      this._fb.control('', [Validators.required])
    );

    if (this.dataEntity) {
      this.form.patchValue({
        allowEdit: this.dataEntity.allowEdit,
        visibleToUser: this.dataEntity.visibleToUser
      });

      if (this.form.controls['allowEdit']) {
        if (this._context.client && (this.dataEntity.isSystemEntity || false)) {
          this.form.controls['allowEdit'].disable();
        } else {
          this.form.controls['allowEdit'].enable();
        }
      }

      if (this.form.controls['visibleToUser']) {
        if (
          this._context.client &&
          (!this.dataEntity.allowEditVisibleToUser || false)
        ) {
          this.form.controls['visibleToUser'].disable();
        } else {
          this.form.controls['visibleToUser'].enable();
        }
      }
    }

    if (this.form.controls['calc-formula']) {
      this.form.controls['calc-formula'].setValue(
        (this.dataEntity?.formulaCriteria || []).length > 0 ? 'done' : ''
      );
    }
  }

  updateCriteria(criteria: ConditionTarget[]) {
    this.dataEntity.formulaCriteria = criteria;

    if (this.form.controls['calc-formula']) {
      this.form.controls['calc-formula'].setValue(
        (criteria || []).length > 0 ? 'done' : ''
      );
    }

    this.updated.emit(this.dataEntity);
  }

  getThenLabel = (clause: ConditionTarget): string => {
    return clause ? clause.value : '';
  }
}

